/* import __COLOCATED_TEMPLATE__ from './brand-phone-dropdown-item.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';

interface Args {
  item: {
    text: string;
    value: string;
    isSelected: boolean;
    componentAttrs: {
      formattedNumber: string;
      hasName: boolean;
      isCalling: boolean;
      isSms: boolean;
      callingTooltip: string;
      smsTooltip: string;
      filterState: {
        showCalling: boolean;
        showSms: boolean;
      };
    };
  };
  selectItem: (item: any) => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class BrandPhoneDropdownItem extends Component<Signature> {
  get isHidden() {
    let { isCalling, isSms, filterState } = this.args.item.componentAttrs;
    if (!filterState.showCalling && !filterState.showSms) {
      return true;
    }
    if (!filterState.showCalling && isCalling && !isSms) {
      return true;
    }
    if (!filterState.showSms && isSms && !isCalling) {
      return true;
    }
    return false;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Brands::BrandPhoneDropdownItem': typeof BrandPhoneDropdownItem;
    'new-settings/workspace/brands/brand-phone-dropdown-item': typeof BrandPhoneDropdownItem;
  }
}
